// 获取头部导航栏内容
export const HEADERCHANNELS = 'header-channels'
